import { DataTableColumnDef } from "@/components/molecules";
import { renderColumnHeaderWithTooltip } from "../helpers";
import { ArchivedVehicleTableData } from "./types";

export const archivedVehiclesColumns: DataTableColumnDef<ArchivedVehicleTableData>[] = [
  {
    header: "Year",
    accessorKey: "year",
    size: 100,
  },
  {
    header: "Make",
    accessorKey: "make",
    cell: (props) => props.row.original.make,
    size: 150,
  },
  {
    header: "Model",
    accessorKey: "model",
    size: 150,
  },
  {
    header: "Number Plate",
    id: "registration_number",
    accessorKey: "numberPlate",
    cell: (props) => props.row.original.numberPlate,
    size: 150,
  },
  {
    header: "Nickname",
    size: 150,
    id: "identifier",
    accessorKey: "nickname",
  },
  {
    header: renderColumnHeaderWithTooltip("Vehicle Type", "Operator-defined vehicle type\nused within your own fleet setup"),
    id: "vehicleType",
    accessorKey: "vehicleType",
    size: 150,
    sortDescFirst: false,
  },
  {
    header: renderColumnHeaderWithTooltip("Vehicle Category", "RideMinder's system category used\nfor matching vehicles to network jobs"),
    id: "vehicleCategory",
    accessorKey: "vehicleCategory",
    size: 175,
    sortDescFirst: false,
  },
  {
    header: "Actions",
    id: "actions",
    cell: (props) => props.row.original.actions,
    maxSize: 75,
  },
];
